<template>
  <div class="pt-2" v-bind:style="{ background: setting.background_color }">
    <div class="row mx-0">
      <div class="col-12">
        <div class="feedback-header">
          <p class="ml-0">Please Answer This Question</p>
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-0">
      <div class="col-12">
        <div class="feedback-option">
          <div class="panel">
            <div class="question-detail">
              <div class="question-number d-flex align-items-center">
                <div class="icon d-flex align-items-center">
                  <img src="../assets/question-icon.svg" alt="" />
                </div>
                <p class="mb-0 title">Question</p>
              </div>
              <h5 class="question-title">{{ currtenQuestion ? currtenQuestion.title : "" }}</h5>
              <p class="question-subtitle">{{ currtenQuestion ? currtenQuestion.description : "" }}</p>
              <div class="question-options">
                <p class="option-head">Select an option to respond:</p>
                <div class="options d-flex align-items-center justify-content-center">
                  <div class="option-item" @click="selectOption('selectVideo')" v-if="currtenQuestion.response_settings.video == 1">
                    <svg width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.8333 7V4.66667C11.8333 4.3 11.5333 4 11.1667 4H3.16667C2.8 4 2.5 4.3 2.5 4.66667V11.3333C2.5 11.7 2.8 12 3.16667 12H11.1667C11.5333 12 11.8333 11.7 11.8333 11.3333V9L14.5 11.6667V4.33333L11.8333 7Z" />
                    </svg>
                    <p class="mb-0">Video</p>
                  </div>
                  <div class="option-item" @click="selectOption('selectAudio')" v-if="currtenQuestion.response_settings.audio == 1">
                    <svg width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8.50016 9.33301C9.60683 9.33301 10.4935 8.43967 10.4935 7.33301L10.5002 3.33301C10.5002 2.22634 9.60683 1.33301 8.50016 1.33301C7.3935 1.33301 6.50016 2.22634 6.50016 3.33301V7.33301C6.50016 8.43967 7.3935 9.33301 8.50016 9.33301ZM12.0335 7.33301C12.0335 9.33301 10.3402 10.733 8.50016 10.733C6.66016 10.733 4.96683 9.33301 4.96683 7.33301H3.8335C3.8335 9.60634 5.64683 11.4863 7.8335 11.813V13.9997H9.16683V11.813C11.3535 11.493 13.1668 9.61301 13.1668 7.33301H12.0335Z"
                      />
                    </svg>
                    <p class="mb-0">Audio</p>
                  </div>
                  <div class="option-item" @click="selectOption('selectImage')" v-if="currtenQuestion.response_settings.image == 1">
                    <svg width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.50003 10.1329C9.67824 10.1329 10.6334 9.17775 10.6334 7.99954C10.6334 6.82134 9.67824 5.86621 8.50003 5.86621C7.32182 5.86621 6.3667 6.82134 6.3667 7.99954C6.3667 9.17775 7.32182 10.1329 8.50003 10.1329Z" />
                      <path
                        d="M6.50016 1.33301L5.28016 2.66634H3.16683C2.4335 2.66634 1.8335 3.26634 1.8335 3.99967V11.9997C1.8335 12.733 2.4335 13.333 3.16683 13.333H13.8335C14.5668 13.333 15.1668 12.733 15.1668 11.9997V3.99967C15.1668 3.26634 14.5668 2.66634 13.8335 2.66634H11.7202L10.5002 1.33301H6.50016ZM8.50016 11.333C6.66016 11.333 5.16683 9.83967 5.16683 7.99967C5.16683 6.15967 6.66016 4.66634 8.50016 4.66634C10.3402 4.66634 11.8335 6.15967 11.8335 7.99967C11.8335 9.83967 10.3402 11.333 8.50016 11.333Z"
                      />
                    </svg>
                    <p class="mb-0">Image</p>
                  </div>
                  <div class="option-item" @click="selectOption('selectText')" v-if="currtenQuestion.response_settings.text == 1">
                    <svg width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.83317 11.333H3.1665V12.6663H9.83317V11.333ZM13.8332 5.99967H3.1665V7.33301H13.8332V5.99967ZM3.1665 9.99967H13.8332V8.66634H3.1665V9.99967ZM3.1665 3.33301V4.66634H13.8332V3.33301H3.1665Z" />
                    </svg>
                    <p class="mb-0">Text</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-0">
      <div class="col-12">
        <router-link class="back-btn d-flex align-items-center" to="/feedback">
          <div class="icon">
            <img src="../assets/angle-left.svg" alt="" />
          </div>
          <div class="text">
            <p class="mb-0">Back</p>
          </div>
        </router-link>
        <div class="d-flex align-items-center justify-content-center">
          <Branding></Branding>
        </div>
      </div>
    </div>
    <div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered reward-modal">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h5 class="modal-title">Reward Details</h5>
            <p class="modal-desc">Must complete a full video submission to get the reward. Only 1 reward per person. Only 25 available. First come first served. Learn more about the reward here:</p>
            <a href="https://www.acme.com/reward-3824" class="link">https://www.acme.com/reward-3824</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from "vue";
// import Vue from "vue";
import Branding from "./partials/branding.vue";

export default {
  name: "Question",
  components: {
    Branding,
  },
  data() {
    return {
      selectVideo: false,
      selectAudio: false,
      selectText: false,
      selectImage: false,
      response: {},
      options: [],
      localCurrentQuestion: {},
      localQuestionList: {},
      currentOption: {},
      currentOptionID: "",
      currtenQuestion: {},
      currentSelectedOption: {}
    };
  },
  props: {
    msg: String,
  },
  created() {
    this.renderComponent();
  },
  watch: {
    "$route.params.id": function() {
      this.renderComponent();
    },
    "$route.params.qid": function() {
      this.renderComponent();
    },
  },
  methods: {
    selectOption(option) {
      if (this.$fromAdminSide) {
        return;
      }
      if (option === "selectVideo") {
        this.$session.set("selectVideo", true);
      } else if (option === "selectAudio") {
        this.$session.set("selectAudio", true);
      } else if (option === "selectText") {
        this.$session.set("selectText", true);
      } else if (option === "selectImage") {
        this.$session.set("selectImage", true);
      }
      if (this.$session.get("currentOption") && this.$session.get("currtenQuestion")) {
        var oid = this.$session.get("currentOption");
        var qid = this.$session.get("currtenQuestion");
        // this.localQuestionList.questions.forEach(function (query){
        //   if(query.option_question_id === qid.option_question_id){
        //     query.answer_type = option
        //     localStorage.setItem('localquestion', JSON.stringify(query))
        //   }
        // })
        // localStorage.setItem('questionList', JSON.stringify(this.localQuestionList));
        this.$router.push({ name: "AnswerView", params: { id: oid.option_unique_id, qid: qid.option_question_id } });
      }
    },
    collapseClick() {
      setTimeout(() => {
        this.$helpers.resizeIframeEvent();
      }, 500);
    },
    renderComponent() {
      if (!this.$route.params.id || !this.$route.params.qid) {
        this.$router.push({ name: "Home" });
      }
      this.response = this.$session.get("response");
      this.setting = this.$session.get("response").settings;
      if (this.$route.params.id) {
        this.currentOptionID = this.$route.params.id;
      } else if (this.$session.get("OptionId")) {
        this.currentOptionID = this.$session.get("OptionId");
      }
      this.$session.set("OptionId", this.$route.params.qid);
      this.currentOption = this.response.options.filter((options) => options.option_unique_id == this.$route.params.id);
      this.currentOption = this.currentOption[0];
      this.$session.set("selectVideo", false);
      this.$session.set("selectAudio", false);
      this.$session.set("selectText", false);
      this.$session.set("selectImage", false);
      // if(!localStorage.getItem('questionList')){
      var questionList = [];
      questionList = { optionId: this.currentOption.option_unique_id, questions: [] };
      this.currentOption.questions.forEach(function(query) {
        questionList.questions.push({ option_question_id: query.option_question_id, unique_id: query.unique_id, answer_type: "", answer: {}, answer_url: "" });
      });
      this.localQuestionList = questionList;
      // }else{
      //   this.localQuestionList =  JSON.parse(localStorage.getItem('questionList'))
      // }
      this.localCurrentQuestion = this.localQuestionList.questions.filter((questions) => questions.option_question_id === this.$route.params.qid);
      this.localCurrentQuestion = this.localCurrentQuestion[0];
      if (this.currentOption.option_unique_id !== this.localQuestionList.optionId) {
        this.$router.push({ name: "Home" });
      }
      this.currtenQuestion = this.currentOption.questions.filter((questions) => parseInt(questions.option_question_id) == parseInt(this.$route.params.qid));
      this.currtenQuestion = this.currtenQuestion[0];
      // console.log('currentQ', this.currtenQuestion.response_settings.video)
      this.$session.set("currtenQuestion", this.currtenQuestion);
      this.$session.set("currentOption", this.currentOption);
    },
    moveToSelectedOption(option_unique_id, option_question_id) {
      if (option_unique_id && option_question_id) {
        this.$router.push({
          name: "QuestionView",
          params: {
            id: option_unique_id,
            qid: option_question_id,
          },
        });
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.$helpers.updateColorAccordingApi();
    });
    window.addEventListener(
      "message",
      (event) => {
        if (event.origin === "http://localhost:8100" || event.origin === "https://vkstg.larkbase.com" || event.origin === "https://app.vouchkick.com") {
          if (event.data.settings) {
            for (let key in event.data.settings) {
              this.response.settings[key] = event.data.settings[key];
            }
            this.$session.set("response", this.response);
            var this_pointer = this;
            setTimeout(function() {
              this_pointer.$helpers.resizeIframeEvent();
            }, 300);
          } else if (event.data.option) {
            this.response = this.$session.get("response");
            this.setting = this.$session.get("response").settings;
            if (this.response.options) {
              this.response.options.forEach((element) => {
                if (element.feedback_option_id == this.currentOption.feedback_option_id) {
                  if (element.questions) {
                    element.questions.forEach((question) => {
                      if (question.option_question_id == this.currtenQuestion.option_question_id) {
                        this.currtenQuestion = question;
                      }
                    });
                  }
                  this.currentOption = element;
                }
              });
            }
          }
          //  else if (event.data.screenAction == "back") {
          //   if (this.$currentScreen == "question") {
          //     if (this.$currentOptionIndex >= 0) {
          //       this.$currentQuestionIndex -= 1;
          //       if (this.$currentQuestionIndex >= 0) {
          //         this.moveToSelectedOption(this.response.options[this.$currentOptionIndex].option_unique_id, this.response.options[this.$currentOptionIndex].questions[this.$currentQuestionIndex].option_question_id);
          //         Vue.prototype.$currentQuestion = this.$currentQuestionIndex;
          //       } else {
          //         if (this.$currentOptionIndex - 1 < 0) {
          //           this.$router.push("/feedback");
          //         } else {
          //           Vue.prototype.$currentOptionIndex = this.$currentOptionIndex - 1;
          //           Vue.prototype.$currentQuestionIndex = this.response.options[this.$currentOptionIndex].questions.length - 1;
          //           if (this.$currentQuestionIndex >= 0) {
          //             this.moveToSelectedOption(this.response.options[this.$currentOptionIndex].option_unique_id, this.response.options[this.$currentOptionIndex].questions[this.$currentQuestionIndex].option_question_id);
          //           }
          //         }
          //       }
          //     } else {
          //       this.$router.push("/feedback");
          //     }
          //   }
          // }
        }
      },
      false
    );
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.feedback-header {
  border-radius: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;

  p {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.01em;
    color: var(--title-color);
    margin: 0;
    margin-left: 8px;
  }
}
.panel {
  .collapse-btn {
    background: #ffffff;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    border-radius: 4px 4px 0px 0px;
    padding: 14px 16px;
    text-decoration: none;
    position: relative;
    z-index: 1;

    .btn-label {
      .icon {
        margin-right: 8px;
      }
      .title {
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 20px;
        letter-spacing: 0.01em;
        color: #56657f;
      }
    }

    &[aria-expanded="true"] {
      .arrow-icon {
        transform: rotateZ(180deg);
      }
    }

    &[aria-expanded="false"] {
      .arrow-icon {
        transform: rotateZ(0deg);
      }
    }
  }
  .collapse-content {
    background: #ffffff;
    border-radius: 0px 0px 5px 5px;
    padding: 24px 16px;
    text-align: left;

    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #56657f;
      margin-bottom: 8px;
    }
  }
}
.feedback-option {
  .panel {
    background: #ffffff;
    border-radius: 4px;
    padding: 18px 10px;

    .question-detail {
      .question-number {
        margin-bottom: 8px;
        .icon {
          margin-right: 8px;
        }
        .title {
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 15px;
          line-height: 24px;
          letter-spacing: 0.01em;
          color: #56657f;
        }
      }

      .question-title {
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.01em;
        color: #313c4e;
        text-align: left;
        margin-bottom: 16px;
      }

      .question-subtitle {
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.01em;
        color: #56657f;
        text-align: left;
        margin-bottom: 32px;
      }

      .question-options {
        .option-head {
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 13px;
          line-height: 20px;
          letter-spacing: 0.01em;
          color: var(--accent-color);
          text-align: left;
        }

        .options {
          .option-item {
            background: var(--accent-color);
            border-radius: 5px;
            width: 100%;
            height: 71px;
            margin-right: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            cursor: pointer;

            &:last-child {
              margin-right: 0px;
            }

            svg {
              margin-bottom: 6px;
              fill: var(--action-btn-color);
            }

            p {
              font-family: "Poppins", sans-serif;
              font-style: normal;
              font-weight: 500;
              font-size: 12px;
              line-height: 18px;
              text-align: center;
              letter-spacing: 0.01em;
              color: var(--action-btn-color);
            }
          }
        }
      }

      .recording-time {
        display: flex;
        align-items: center;
        justify-content: start;
        padding: 12px;
        background: #ffffff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
        border-radius: 5px;
        margin-top: 16px;

        img {
          margin-right: 10px;
        }

        .title {
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 13px;
          line-height: 20px;
          letter-spacing: 0.01em;
          color: #313c4e;
          margin-bottom: 0px;
        }

        .time {
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          letter-spacing: 0.01em;
          color: var(--accent-color);
          margin-bottom: 0px;
          margin-left: 10px;
        }
      }
    }
  }
}
.back-btn {
  margin-bottom: 35px;
  .icon {
    margin-right: 8px;
  }
  .text {
    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #56657f;
    }
  }
}
.copyright {
  display: flex;
  align-items: flex-end;
  margin-bottom: 15px;
  padding: 5px 11px;
  background: #fff;
  margin-bottom: 15px;
  border-radius: 40px;
  .icon {
    margin-right: 4.84px;
    display: flex;
    align-items: flex-end;
    padding-bottom: 3px;
  }
  .text {
    p {
      font-family: "Mulish", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 15px;
      color: #8997b1;
    }
  }
}
a {
  text-decoration: none;
}
</style>
